import { createSlice } from '@reduxjs/toolkit';

// Initial state
// const initialState = {
//   isAuthenticated: false,
//   user: null,
// };
const initialState = {
  isAuthenticated: false,
  user: null,
  
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    saveSession(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    // logout(state) {
    //   state.isAuthenticated = false;
    //   state.user = null;
    // },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      localStorage.removeItem('authToken');  // Remove token from local storage
    },
  },
});

// Export actions
export const { saveSession, logout } = authSlice.actions;

// Export reducer
export default authSlice.reducer;
